import { ListingDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import { ListingLabelContext } from 'contexts';
import React from 'react';

export type NoMoreShowingsProps = {
  listing: JsonObject<ListingDoc>;
  availability: string;
  allowOverride?: boolean;
  updateState?: (f: (draft: any) => void) => void;
};

export const NoMoreShowings: React.FC<NoMoreShowingsProps> = ({
  listing,
  updateState,
  availability,
  allowOverride,
}) => {
  const { getAvailability } = React.useContext(ListingLabelContext);

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <h4>No More Showings</h4>
          <h5>Property Status: {getAvailability(availability)}</h5>
          {allowOverride && (
            <div className="row" style={{ marginTop: '20px' }}>
              <div className="col-md-6">
                <a
                  className="btn btn-default margin-right"
                  href={`/#/listing/${listing.id}/view`}
                >
                  Cancel
                </a>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    updateState(draft => {
                      draft.noMoreShowings = false;
                    });
                  }}
                >
                  Override, Book Showing
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NoMoreShowings;
